import React from 'react';
import cn from 'classnames';
import styles from './BindTitle.module.scss';

const BindTitle = ({ className, ...props }) => (
  <h3 {...props} className={cn(styles.root, className)} />
);

export default BindTitle;
